// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pz-identity-hint[data-v-7381e72e] {\n  font-size: 12px;\n  line-height: 1.4;\n  color: #8492a6;\n  margin-top: 4px;\n}\n.disabled[data-v-7381e72e] {\n  pointer-events:none;\n  color: #bfcbd9;\n  cursor: not-allowed;\n  background-image: none;\n  background-color: #eef1f6;\n  border-color: #d1dbe5;\n}\n", ""]);
// Exports
module.exports = exports;
